import { render, staticRenderFns } from "./ApprovalType.vue?vue&type=template&id=58cce876&scoped=true&"
import script from "./ApprovalType.vue?vue&type=script&lang=js&"
export * from "./ApprovalType.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalType.vue?vue&type=style&index=0&id=58cce876&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cce876",
  null
  
)

export default component.exports